/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-pay-pal-validated',
  templateUrl: './pay-pal-validated.component.html',
  styleUrls: ['./pay-pal-validated.component.scss']
})
export class PayPalValidatedComponent implements OnInit {

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    // This is intentional
  }

}
